import { render, staticRenderFns } from "./Firmador.vue?vue&type=template&id=1947d8b6&scoped=true"
import script from "./Firmador.vue?vue&type=script&lang=js"
export * from "./Firmador.vue?vue&type=script&lang=js"
import style0 from "./Firmador.vue?vue&type=style&index=0&id=1947d8b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947d8b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1947d8b6')) {
      api.createRecord('1947d8b6', component.options)
    } else {
      api.reload('1947d8b6', component.options)
    }
    module.hot.accept("./Firmador.vue?vue&type=template&id=1947d8b6&scoped=true", function () {
      api.rerender('1947d8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firmador/Firmador.vue"
export default component.exports